import { isFobSelection } from '@mobi/betslip/helpers/typeGuards'
import {
  subscribe as iotSubscribe,
  unsubscribe as iotUnsubscribe,
} from '@core/State/PushData/awsIot'
import { getFobPriceChangeByPropositionTopic } from '@core/State/PushData/topics'
import { BetslipItem } from '../driver'

export const startIotSubscription = (item: BetslipItem): BetslipItem => {
  if (item.selection && isFobSelection(item.selection) && !item.hasIotSubscription) {
    iotSubscribe([getFobPriceChangeByPropositionTopic(item.selection.propositionSeq)])
    return { ...item, hasIotSubscription: true }
  }
  return item
}

export const stopIotSubscription = (item: BetslipItem): BetslipItem => {
  if (item.selection && isFobSelection(item.selection) && item.hasIotSubscription) {
    iotUnsubscribe([getFobPriceChangeByPropositionTopic(item.selection.propositionSeq)])
    return { ...item, hasIotSubscription: false }
  }
  return item
}
